/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Chevron-left2': {
    width: 10,
    height: 14,
    viewBox: '0 0 10 14',
    data: '<path pid="0" _fill="#D3D4D6" d="M0 0h10v13.33H0z"/><path pid="1" d="M7.637 11.312c.481.458.481 1.2.016 1.674a1.21 1.21 0 01-.866.347c-.305 0-.61-.11-.835-.347L.353 7.507A1.174 1.174 0 010 6.671c0-.316.128-.616.353-.837l5.6-5.479a1.195 1.195 0 011.7 0 1.164 1.164 0 01-.016 1.674L2.904 6.67l4.733 4.641z" _fill="#00204D"/>'
  }
})
